import React, { useState, useEffect } from "react";
import ReportRecruitment from "./ReportRecruitment";
import moment from "moment";
import { authAxios } from "../../../utils";
import Cookies from "universal-cookie";
import { url_report_recruitment, url_export_rect } from "../../../constants";
import { openNotificationWithIcon } from "../../Function";

const cookies = new Cookies();

const Index = () => {
  // const [form] = Form.useForm();
  const [dataReport, setDataReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);

  // const ls_city = useSelector((state) => state.user.ls_city);
  // const ls_department = useSelector((state) => state.user.ls_department);
  // const ls_ticket_status = useSelector((state) => state.user.ls_ticket_status);
  const [dateNow, setDateNow] = useState([
    moment(new Date()).subtract(6, "months"),
    moment(new Date()),
  ]);

  const fetchReportRecruitment = (params = {}) => {
    setLoading(true);
    authAxios(cookies.get("token"))
      .get(url_report_recruitment, { params: params })
      .then((res) => {
        setDataReport(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("error", "Lỗi", err.data.message);
          }
        }

        // openNotificationWithIcon('success','Thành công','');
      });
  };

  const onClickFileDownload = () => {
    setLoadingReport(true);
    const fnFileDownload = require("js-file-download");
    const filename =
      "Report_Recruitment" +
      "_" +
      dateNow[0].format("YYYYMMDD") +
      "_" +
      dateNow[1].format("YYYYMMDD") +
      ".xlsx";
    var FormData = require("form-data");
    var data = new FormData();
    data.append("from_date", dateNow[0].format("YYYY-MM-DD"));
    data.append("to_date", dateNow[1].format("YYYY-MM-DD"));
    authAxios(cookies.get("token"))
      .post(url_export_rect, data, { responseType: "blob" })
      .then((res) => {
        fnFileDownload(res.data, filename);
        setLoadingReport(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingReport(false);
      });
  };

  const setRangeDate = (value) => {
    setDateNow([
      moment(value[0], "DD/MM/YYYY"),
      moment(value[1], "DD/MM/YYYY"),
    ]);
  };
  const onSearch = () => {
    fetchReportRecruitment({
      from_date: dateNow[0].format("YYYY-MM-DD"),
      to_date: dateNow[1].format("YYYY-MM-DD"),
    });
  };

  useEffect(() => {
    fetchReportRecruitment({
      from_date: dateNow[0].format("YYYY-MM-DD"),
      to_date: dateNow[1].format("YYYY-MM-DD"),
    });
  }, []);

  return (
    <ReportRecruitment
      dateNow={dateNow}
      setRangeDate={setRangeDate}
      loading={loading}
      dataReport={dataReport}
      onSearch={onSearch}
      onClickFileDownload={onClickFileDownload}
      loadingReport={loadingReport}
    />
  );
};

export default Index;
